export default {
  calendarApi: {
    init: '/api/calendar/init',
    getAllDays: 'api/calendar/getAllDays',
    getConfigByYear: 'api/calendar/getConfigByYear',
    initWithConfig: 'api/calendar/initWithConfig',
    getCalendar: 'api/calendar/getCalendar'
  }
}